import { Box, Link, Typography } from '@mui/material';
import type { Section } from './content';

/**
 * "On this page" navigation. A compact two-column list above the content on
 * mobile; a sticky rail beside it on desktop (the parent sets the order).
 */
export function DocsNav({ sections }: { sections: readonly Section[] }) {
  return (
    <Box
      component="nav"
      aria-label="On this page"
      sx={{
        width: { xs: '100%', md: 200 },
        flexShrink: 0,
        position: { md: 'sticky' },
        top: { md: 40 },
        alignSelf: 'flex-start',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'IBM Plex Mono',
          fontSize: '0.6875rem',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          color: 'var(--ink-muted)',
          mb: 1.5,
        }}
      >
        On this page
      </Typography>
      <Box
        component="ul"
        sx={{
          m: 0,
          p: 0,
          listStyle: 'none',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr 1fr', md: '1fr' },
          columnGap: 3,
          rowGap: 0.75,
        }}
      >
        {sections.map((section) => (
          <li key={section.id}>
            <Link
              href={`#${section.id}`}
              underline="none"
              sx={{
                fontSize: '0.8125rem',
                color: 'var(--ink-muted)',
                '&:hover': { color: 'var(--ink)' },
              }}
            >
              {section.title}
            </Link>
          </li>
        ))}
      </Box>
    </Box>
  );
}
